// Mock data for Dashboard component
export const mockDashboardData = {
  integrations: {
    total: 24,
    active: 18,
    inactive: 4,
    error: 2,
  },
  performance: {
    successRate: 98.5,
    avgResponseTime: 245,
    throughput: 1250,
  },
  alerts: {
    critical: 2,
    warning: 5,
    info: 8,
  },
};

export const mockIntegrations = [
  {
    id: 1,
    name: 'SAP ERP Connection',
    type: 'ERP',
    status: 'active',
    lastSync: '2 min ago',
    successRate: 99.2,
  },
  {
    id: 2,
    name: 'Customer Database',
    type: 'Database',
    status: 'active',
    lastSync: '5 min ago',
    successRate: 98.7,
  },
  {
    id: 3,
    name: 'Payment Gateway',
    type: 'API',
    status: 'warning',
    lastSync: '15 min ago',
    successRate: 95.1,
  },
  {
    id: 4,
    name: 'Inventory System',
    type: 'ERP',
    status: 'active',
    lastSync: '1 min ago',
    successRate: 99.8,
  },
  {
    id: 5,
    name: 'Email Service',
    type: 'SMTP',
    status: 'error',
    lastSync: '30 min ago',
    successRate: 87.3,
  },
  {
    id: 6,
    name: 'Analytics API',
    type: 'API',
    status: 'active',
    lastSync: '3 min ago',
    successRate: 96.4,
  },
];

export const mockRecentAlerts = [
  {
    id: 1,
    type: 'error',
    message: 'Payment gateway connection timeout',
    timestamp: '5 minutes ago',
    integration: 'Payment Gateway',
  },
  {
    id: 2,
    type: 'warning',
    message: 'High response time detected',
    timestamp: '15 minutes ago',
    integration: 'Customer API',
  },
  {
    id: 3,
    type: 'info',
    message: 'Scheduled maintenance completed',
    timestamp: '1 hour ago',
    integration: 'System',
  },
];

